import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkbox-checked",
  "use": "icon-checkbox-checked-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-checkbox-checked\"><path d=\"M896 0l-768 0c-70.4 0-128 57.6-128 128l0 768c0 70.4 57.6 128 128 128l768 0c70.4 0 128-57.6 128-128l0-768c0-70.4-57.6-128-128-128zM448 794.496l-237.248-237.248 90.496-90.496 146.752 146.752 306.752-306.752 90.496 90.496-397.248 397.248z\" p-id=\"2873\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol